export const APPSTORE_LINK = "https://apps.apple.com/app/id1022341873";
export const PLAYSTORE_LINK = "https://play.google.com/store/apps/details?id=com.biddl.biddl";
export const UNIVERSAL_APP_LINK = "https://blidz.app.link/download/web";

// Marketing OneLink template (WEB-107, template id 4JS3), used by the lp/ landing pages.
// Campaign links are long links: `${ONELINK_MARKETING_BASE}?pid=<channel>&c=<variant>&deep_link_value=<dest>`.
export const ONELINK_MARKETING_BASE = "https://blidz.onelink.me/4JS3";
